<div class="dialog-shell">
  <header class="dialog-header">
    <div>
      <div class="eyebrow">Calendar</div>
      <h2>Select a day</h2>
      <p>Pick any date from the full calendar. We’ll return it to the caller.</p>
    </div>
    <div class="header-actions">
      <button mat-stroked-button color="primary" (click)="useToday()">Today</button>
    </div>
  </header>

  <section class="calendar-wrap">
    <mat-calendar
      [startAt]="startAt"
      [selected]="selected"
      [minDate]="minDate"
      (selectedChange)="choose($event)"
    ></mat-calendar>
    <aside class="details">
      <div class="pill">Selected</div>
      <div class="big-date">{{ selected | date: 'EEEE, MMM d, y' }}</div>
      <div class="hint">Tap any day on the calendar to update, or use a quick pick.</div>
      <div class="quick-picks">
        <div class="quick-picks__label">Quick picks</div>
        <div class="quick-picks__buttons">
          <button mat-stroked-button color="primary" (click)="pickRelative({ days: 7 })">1 week</button>
          <button mat-stroked-button color="primary" (click)="pickRelative({ months: 1 })">1 month</button>
          <button mat-stroked-button color="primary" (click)="pickRelative({ months: 6 })">6 months</button>
          <button mat-stroked-button color="primary" (click)="pickRelative({ years: 1 })">1 year</button>
        </div>
      </div>
    </aside>
  </section>

  <footer class="dialog-actions">
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" (click)="confirm()">Use this day</button>
  </footer>
</div>
